// 
// Ecommlab Cart Total Savings
// - 
// 
window.theme = window.theme || {};

theme.CartTotalSavings = (function() {

  function CartTotalSavings(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.sectionId = this.container.id;

    this.bindElements();
    this.bindEvents();

  }

  CartTotalSavings.prototype = {

    bindElements: function(){
      const self = this;
      self.totalSavingsContainer = this.container.querySelector('[data-total-savings]');
    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

      document.addEventListener('ajaxProduct:added', function(event) {
        self.onPageLoad();
      });

      document.addEventListener('cart:updated', function(event) {
        let cart = event.detail.cart;
        
        if (!cart){
          console.log('Error: invalid variant id');
        }
        else {
          self.onPageLoad();
          return;
        }

        self.handleCartUpdate(cart);

      });

      document.addEventListener('cart:quantity', function(event) {
        let cart = event.detail.cart;
        
        if (!cart){
          console.log('Error: invalid variant id');
        }
        else {
          self.onPageLoad();
          return;
        }

        self.handleCartUpdate(cart);

      });
    },

    handleCartUpdate: async function(cart){
      const self = this;

      self.cart = cart;
      self.savings = await self.getFullCartDetails();
      self.updateTotalSavings();

    },

    onPageLoad: async function(){
      const self = this;

      self.cart = await self.getCart();
      self.savings = await self.getFullCartDetails();
      self.updateTotalSavings();
    },

    getFullCartDetails: function(){
      const self = this;
      return new Promise(function(resolve, reject) {

        fetch(`/cart?view=data`)
        .then(res => res.text())
        .then(html => {
          if (html){
            let data = JSON.parse(html);
            resolve(data.total_savings);
          } 
        })
        .catch(error => {
          console.log(error);
          resolve();
        });

      });
    },

    updateTotalSavings: function(){
      const self = this;

      self.totalSavingsContainer.innerHTML = self.savings;
    },

    getCart: async function(){
      const self = this;

      return new Promise(function(resolve, reject) {

        fetch('/cart.js')
        .then(res => res.text())
        .then(html => {
          if (html){
            resolve(JSON.parse(html));
          } 
        })
        .catch(error => {
          console.log(error);
          resolve();
        })
      });
    }

  }

  return CartTotalSavings;

})();

document.addEventListener('DOMContentLoaded', function() {
  const cartTotalSavingsContainers = document.querySelectorAll('.site-header__cart');
  if (!window.theme.cartTotalSavings && cartTotalSavingsContainers){
    window.theme.cartTotalSavings = [];
    cartTotalSavingsContainers.forEach(function(container){
      window.theme.cartTotalSavings.push(new theme.CartTotalSavings(container));
    });
  }
});
